import { createModel } from '@rematch/core'
import * as firebase from 'firebase'
import * as R from 'ramda'

interface IState {
  [orderId: string]: IOrder
}

export default createModel({
  state: {} as IState,
  reducers: {
    updateById: (state: IState, payload: { orderId: string, order: IOrder }): IState => ({
      ...state,
      [payload.orderId]: payload.order,
    }),
    removeById: (state: IState, orderId: string) => {
      const { [orderId]: order, ...restState } = state
      return restState
    }
  },
  effects: {
    async fetchOrders() {
      const currentUser = firebase.auth().currentUser
      if (currentUser === null) {
        throw Error('請先登入會員')
      }
      const ref = await firebase.firestore().collection('orders')
        .where('participantId', '==', currentUser.uid)
        .get()
      ref.docs.map(doc => {
        const orderId = doc.id
        const order = doc.data() as IOrder
        this.updateById({ orderId, order })
      })
    },
    async deleteOrderById(orderId: string) {
      await firebase.firestore().collection('orders').doc(orderId).delete()
      this.removeById(orderId)
    },
  },
  selectors: {
    getById: (state: IState, orderId: string) => {
      return state[orderId] ? state[orderId] : null
    },
    getPaidOrders: (state: IState) => {
      return R.filter(order => order.result !== undefined && order.result.RtnCode === '1', R.values(state))
    },
    getUnpaidOrders: (state: IState) => {
      return R.filter(order => order.result === undefined, R.values(state))
    },
    getFailedOrders: (state: IState) => {
      return R.filter(order => order.result !== undefined && order.result.RtnCode !== '1', R.values(state))
    },
  }
})


// WEBPACK FOOTER //
// ./src/models/orders.ts